export default __webpack_public_path__ + "static/media/A_Accessories.a684ff08.jpg";